
import { mapState, mapGetters } from "vuex";
import reportItemWiseSalesTable from "./report-item-wise-sales-table.vue";
import VueHtml2pdf from "vue-html2pdf";
import writeXlsxFile from "write-excel-file";
import ReportOrdersTable from "./report-orders-table.vue";
import ReportChannelOrderTable from "./report-channel-order-table.vue";
import { reportOrdersHeader } from "../../constants/Others";
import { itemWiseSalesHeaderForExcel } from "../../constants/Others";
import { summaryReportHeader } from "../../constants/Others";
export default {
  components: {
    reportItemWiseSalesTable,
    VueHtml2pdf,
    ReportOrdersTable,
    ReportChannelOrderTable
  },
  data() {
    return {
      timeList: [
        { value: "orders", label: "Orders" },
        { value: "item-wise-report", label: "Item-Wise Report" },
        { value: "summary-report", label: "Summary Report" },
        {
          value: "gst-filing-report",
          label: "GST Filing Report",
          isComingSoon: true
        }
      ],
      formats: [
        { value: "pdf", label: "PDF Document (.pdf)" },
        { value: "excel", label: "Microsoft Excel (.xlsx)" }
      ],
      format: "pdf",
      loading: false,
      selectedItems: [],
      processingItem: ""
    };
  },
  computed: {
    ...mapState("report", [
      "selectedStartDate",
      "selectedEndDate",
      "ordersLoading",
      "reportLoading",
      "products",
      "summary"
    ]),
    ...mapGetters("report", [
      "getSelectedRestaurantsLabel",
      "getOrdersListReport",
      "getChannels",
      "getTotalObjForSummaryReport"
    ]),
    ...mapState("auth", ["user"])
  },
  methods: {
    getFileName(item) {
      return `${this.getSelectedRestaurantsLabel}_${item}_${this.selectedStartDate}_To_${this.selectedEndDate}`;
    },
    async downloadAction() {
      this.loading = true;
      const $this = this;
      if (this.format === "pdf") {
        this.selectedItems.forEach(async (el) => {
          await this.sleep(1000);
          this.processingItem = el;
          await $this.$refs["html2Pdf__" + el][0].generatePdf();
        });
      } else if (this.format === "excel") {
        this.selectedItems.forEach(async (el) => {
          let HEADER_ROW = [];
          let DATA_ROW = [];

          switch (el) {
            case "orders":
              //  For Orders Report
              HEADER_ROW = reportOrdersHeader.map((el) => ({
                value: el.text,
                type: String
              }));

              DATA_ROW = this.getOrdersListReport.map((item) => {
                let row = [];
                reportOrdersHeader.forEach((el) => {
                  let value;
                  if (el.value === "status") {
                    value = this.getOrderStatusConstObj(item[el.value])?.label;
                  } else {
                    value = String(
                      el.innerValue
                        ? item[el.value][el.innerValue]
                        : item[el.value]
                    );
                  }
                  row.push({ value, type: String });
                });
                return row;
              });
              break;

            case "item-wise-report":
              //  for Sales wise Item report
              const titles = JSON.parse(
                JSON.stringify(itemWiseSalesHeaderForExcel)
              );
              titles.splice(2, 0, ...this.getTitlesArrayForChannels());

              HEADER_ROW = titles.map((el) => ({
                value: el.text,
                type: String
              }));

              DATA_ROW = this.getModifiedItemList().map((item) => {
                let row = [];

                titles.forEach((el) => {
                  let result = item.find((prop) => prop.value === el.value);
                  let value = String(
                    el.innerValue ? result[el.innerValue] : result.label
                  );

                  row.push({ value, type: String });
                });
                return row;
              });
              break;

            case "summary-report":
              //  for Summary Report
              HEADER_ROW = summaryReportHeader.map((el) => ({
                value: el.label,
                type: String
              }));
              let summaryReport = [...this.summary];
              summaryReport.push(this.getTotalObjForSummaryReport);

              DATA_ROW = summaryReport.map((item) => {
                let row = [];
                summaryReportHeader.forEach((el, columnIndex) => {
                  let value =
                    el.key in item ? String(item[el.key]) : String(item.label);
                  row.push({ value, type: String });
                });
                return row;
              });
              break;
          }
          const fileName = this.getFileName(el);

          if (this.isAndroid()) {
            const blobData = await writeXlsxFile([HEADER_ROW, ...DATA_ROW]);
            this.hasDownloaded(blobData);
          } else {
            await writeXlsxFile([HEADER_ROW, ...DATA_ROW], {
              fileName: fileName
            });
          }
          this.loading = false;
        });
      }
    },
    getTitlesArrayForChannels() {
      let channelTitles = [];
      this.getChannels.forEach((channel) => {
        channelTitles.push({
          value: `${channel}`,
          innerValue: "label",
          text: `Items sold on ${channel}`
        });
        channelTitles.push({
          value: `${channel}`,
          innerValue: "amount",
          text: `Total sale on ${channel}`
        });
      });
      return channelTitles;
    },
    async hasDownloaded(fileData) {
      this.loading = false;
      if (this.isAndroid()) {
        const base64File = await this.blobToBase64(fileData);
        Android.initFileDownload(
          base64File,
          this.getFileName(this.processingItem)
        );
      }
    },
    getTotalPrice() {
      let itemTotalPrice = 0;
      this.products?.forEach((item) => {
        this.getChannels.forEach((channel) => {
          itemTotalPrice += Number(item.price) * Number(item[channel]);
        });
      });
      return itemTotalPrice;
    },
    getModifiedItemList() {
      let items = [];
      let itemTotalPrice = this.getTotalPrice();
      this.products?.forEach((item) => {
        let row = [
            {
              value: "name",
              label: item.name,
              amount: item.price
            }
          ],
          data = {},
          totalCount = 0,
          totalAmount = 0;

        this.getChannels.forEach((channel) => {
          totalCount += item[channel];
          data.value = `${channel}`;
          data.label = item[channel];
          data.amount = item.price * item[channel];
          row.push({ ...data });
        });

        data.value = "total";
        data.label = totalCount;
        data.amount = totalCount * item.price;
        row.push({ ...data });

        data.value = "revenue";
        data.label =
          Math.round(((totalCount * item.price) / itemTotalPrice) * 10000) /
          100;
        row.push({ ...data });

        items.push(row);
      });
      return items;
    }
  }
};
